import React from 'react'
import {Link} from 'react-router-dom'
import {SignInLayout} from './SignInLayout'
import {Button,Dialog} from 'startlibs/lib/components'
import {withForm, Errors, Field, Form, TextInput, SimpleCheckbox} from 'startlibs/lib/form'
import {getFetcher, formFetch} from 'startlibs'
import {withToggles, withRouteTo} from 'startlibs/lib/hocs'
import {signIn} from '../reducers'
import {buildValidation, required, responseFailure} from '../lib/validation'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {ice} from 'icepath'
import load from 'little-loader'

const defaultProps = {rememberMe: true}

const doRedirect = ['/activated', '/profile', '/workstations', '/changePassword', '/account-settings', '/checkout', '/billing', /\/deleteAccount\/.*/, /\/reportCleanup\/.*/, /\/report\/.*/]
export const NOT_ACTIVATED_ERROR = (email) => `This account is not activated yet. Please check ${email} and click the activation link to finish sign up.`

@withRouter
@withRouteTo
@withToggles('loading','activationFeedback')
@withForm(formFetch)
@connect(undefined, {signIn})
class SignInContent extends React.Component {

  onFailure = (...args) => {
    this.failedUsername = this.props.form.properties.username
    this.failedTime = Date.now()
    const {response} = args[1]
    if (response.detail && response.detail.indexOf(' has not activated') >= 0) {
      return this.props.activationFeedback.open()
    }
    return responseFailure(this.props.form,
      ({detail,message}) =>
        (detail === 'Bad credentials' && {'': ['Invalid e-mail and password combination']}) ||
        (detail && detail.indexOf(' check your e-mail to reactivate') >= 0 && {'username': [`This account has been previously deleted. To reactivate the account please check ${this.props.form.properties.username} and click the reactivation link.`]})
    )(...args)
  }

  onSuccess = () => {
    localStorage.setItem('hasLogged', 'true')
    const url = this.props.originalLocation
    this.props.loading.open()
    getFetcher('/api/account')
      .then((result) => this.props.signIn(result))
      .then(() => {
        if (doRedirect.find( _ => _.test ? _.test(url) : _===url)) {
          this.props.history.push(this.props.originalLocation)
        } else {
          this.props.history.push('/')
        }
      })
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.history.push('/')
    }
  }



  preValidation = buildValidation({
    password: [required],
    username: [required,
      () =>
        this.props.form.properties.username === this.failedUsername &&
        ice.get(this.props.form, ['errors', 'username', 0]) === NOT_ACTIVATED_ERROR &&
        this.failedTime + (1000 * 30) > Date.now() &&
        NOT_ACTIVATED_ERROR(this.props.form.properties.username)
    ]
  })

  render() {
    const {form,loading, activationFeedback} = this.props
    return (
      <div>
        <div className="opening-section">
          <h1>Sign in to Horos Cloud</h1>
          <h3>Enter your details below</h3>
        </div>
        <Form
          alwaysSave
          preValidation={this.preValidation}
          onSuccess={this.onSuccess}
          onFailure={this.onFailure}
          form={form}
          url='/api/authenticate'
          defaultProperties={defaultProps}
        >
          <TextInput
            tabIndex={1}
            label="E-mail:"
            placeholder="example@email.com"
            form={form}
            path="username"
          />
          <Field label="Password:">
            <Link className={(Object.keys(form.errors).length ? 'has-error ' : '') + 'password-link'} to="/recovery"
                  tabIndex={2}>Forgot password?</Link>
            <TextInput
              tabIndex={1}
              type="password"
              form={form}
              withoutField
              path="password"
              placeholder="Enter your password"
            />
          </Field>
          <div className="checkbox-list">
            <SimpleCheckbox
              form={form}
              label="Keep me signed in while in this computer"
              path="rememberMe"
            />
          </div>
          <div className="form-actions">
            <Button isLoading={form.isLoading || loading.isOpen} className="highlight with-loader" tabIndex={1} type="submit">Sign
              in</Button>
          </div>
          <Errors form={form}/>
        </Form>
        {
          activationFeedback.isOpen &&
            <ActivationFeedbackDialog email={this.props.form.properties.username} closeDialog={activationFeedback.close} />
        }
      </div>
    )
  }
}

const ActivationFeedbackDialog = ({email,closeDialog}) =>
  <Dialog
    closeDialog={closeDialog}
    title="Please activate your account"
  >
    <Dialog.Content>
      <p>Your email is not verified yet.</p>
      <p>Please check <b>{email}</b> and click the activation link to validate your account and sign in.</p>
      <p className="additional-info">If you do not find the email in your inbox, please check your spam or junk
        folder.</p>
    </Dialog.Content>
    <Dialog.Footer>
      <Button highlight onClick={closeDialog}>Ok</Button>
    </Dialog.Footer>
  </Dialog>

class SignInFooter extends React.Component {

  componentDidMount() {
    load("https://fast.wistia.com/embed/medias/oa5uzcuxxp.jsonp")
    load("https://fast.wistia.com/assets/external/E-v1.js")
  }

  render() {
    return (
      <div>
        <div className="signup-question"><span>Don't have an account?</span><Link className="button outline" to="/signUp">Sign
          up</Link>
        </div>
      </div>
    )
  }
}

export const SignIn = (props) => <SignInLayout contentProps={props} Content={SignInContent} Footer={SignInFooter}/>


// WEBPACK FOOTER //
// ./src/javascripts/signin/SignIn.jsx